export default "__VITE_ASSET__BRNEsc$T__"